import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import "./dropdown.css";

const Dropdown = ({ title, children, className }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`dropdown ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="dropdown-button"
      >
        <span className="dropdown-title">{title}</span>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </button>
      {isOpen && <div className="dropdown-content">{children}</div>}
    </div>
  );
};

export default Dropdown;
